import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, 
    // MensajeSiNo 
} from '../../mensajes';

import { Dimmer } from "../../spinner";

// import { validaSoloNumero, validaNumeroTelefono, validaEmail } from '../../../util/varios';
// import axios from 'axios';
// import moment from 'moment';

export const ImpporSector = (props) => {

    /*  variables de estados */

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnSalir = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    // const [mostrar2, setMostrar2] = useState(false);
    // const [mostrar3, setMostrar3] = useState(false);
    // const [titulo2, setTitulo2] = useState();
    // const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    // const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    // const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    // const [contar, setContar] = useState(0);
    // const [contar1, setContar1] = useState(0);
    // const [contar2, setContar2] = useState(0);
    // const [tecla, setTecla] = useState();
    const [anio, setAnio] = useState();
    const [habilitadoNR, setHabilitadoNR] = useState(false);
    // const [visibleF, setVisibleF] = useState('hidden');
    // const [visibleA, setVisibleA] = useState('hidden');
    // const radioTodasFecha = useRef();
    // const radioSeleccionarFecha = useRef();
    const txtAnio = useRef();
    const cmbTipo = useRef();
    const txtActivo = useRef();
    const txtInactivo = useRef();
    const txtClausurado = useRef();
    const txtDpLegal = useRef();
    const txtExonerado = useRef();
    const txtRCerrado = useRef();
    const txtNotificado = useRef();
    const txtFiscal = useRef();
    const txtSectorDesde = useRef();
    const txtSectorHasta = useRef();


    let op = require('../../../../src/modulos/datos');

    useEffect(() => {


        let anioact = JSON.parse(localStorage.getItem('anioactu'));
        var nanio = []
        var aini = parseInt(anioact) - 7;
        var afin = parseInt(anioact);

        for (let i = 0; i + aini <= afin; i++) {
            nanio.push({ anio: afin - i });

        }
        setAnio(nanio);

    }, []);

    const cancelar = (e) => {
        e.preventDefault();
        setHabilitadoNR(false);
        blanquear();
        props.setShow();

    }

    const blanquear = () => {

        setMostrar1(false);
        setActivate(false);
        setMsg('');

    }

    const imprimirReporte = () => {

        var sigue = true;

        if (sigue) {
            var reporte = '';
            var sql = '';
            var sql2 = '';
            var sql3 = '';
            var sql4 = '';
            var sql5 = '';


            if (props.tabla === 4) {
                reporte = 'ListPublicComerc';
                var a = txtActivo.current.checked ? "51," : "0,";
                var i = txtInactivo.current.checked ? "52," : "0,";
                var c = txtClausurado.current.checked ? "53," : "0";
                var b = txtFiscal.current.checked ? "54," : "0,";
                var d = txtNotificado.current.checked ? "55," : "0,";
                var e = txtDpLegal.current.checked ? "56," : "0,";
                var f = txtExonerado.current.checked ? "57," : "0,";
                var g = txtRCerrado.current.checked ? "58" : "0";
                var status_cade = a + i + c + b + d + e + f + g;
                sql = "sectorcatastral between"
                    + " '"
                    + txtSectorDesde.current.value.trim()
                    + "' "
                    + "and"
                    + " '"
                    + txtSectorHasta.current.value.trim() + "' " + " and (anio=" + txtAnio.current.value + ")";
                sql2 = "Desde Sector: "
                    + txtSectorDesde.current.value.trim() + "  "
                    + "Hasta Sector:"
                    + txtSectorHasta.current.value.trim();
                sql3 = "cuenta";
                sql4 = "por Sector";
                sql5 = "";
                sql4 = "CONTRIBUYENTES " + cmbTipo.current.value.trim();
                if (cmbTipo.current.value.trim() === "TODOS") {
                    sql5 = " AND STATUS IN (" + status_cade + ")";
                } else {
                    sql5 = " AND STATUS IN (" + status_cade + ") AND " + "TIPOCONTRIBUYENTE = '" + cmbTipo.current.value.trim() + "'";
                }
            }
            window.open(op.reportes + "/propagandapublicidad?" + "reporte=" + reporte + "&sql=" + sql + "&sql2=" + sql2 + "&sql3=" + sql3 + "&sql4=" + sql4 + "&sql5=" + sql5, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");





        }

    };

    const salir = () => {

        props.setShow(false);
    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtAnio.current.value === '') {
            setTitulo('Error');
            setMsg('Seleccione el Año');
            sigue = false;
            txtAnio.current.focus();
            setMostrar(true);
        } else if (cmbTipo.current.value === "") {
            setTitulo('Error');
            setMsg('Seleccione el Tipo');
            sigue = false;
            cmbTipo.current.focus();
            setMostrar(true);
        } else if (txtSectorDesde.current.value === "") {
            setTitulo('Error');
            setMsg('Introduzca el Sector Desde');
            sigue = false;
            txtSectorDesde.current.focus();
            setMostrar(true);
        } else if (txtSectorHasta.current.value === "") {
            setTitulo('Error');
            setMsg('Introduzca el Sector Hasta');
            sigue = false;
            txtSectorHasta.current.focus();
            setMostrar(true);
        } else if (txtActivo.current.checked === false && txtInactivo.current.checked === false && txtClausurado.current.checked === false &&
             txtFiscal.current.checked === false && txtNotificado.current.checked === false && txtDpLegal.current.checked === false && 
             txtExonerado.current.checked === false && txtRCerrado.current.checked === false) {
            setTitulo('Error');
            setMsg('Seleccione el Estatus de la Consulta');
            sigue = false;
            txtActivo.current.focus();
            setMostrar(true);
        } else if (sigue === true) {
            imprimirReporte();
        }
    }

    const handleCloseMensa = (e) => {
        e.preventDefault();
        setMostrar(false);

    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}>
            <Modal.Header className='azulGradiant' style={{ height: '40px'}}>
                <div style={{ color: "#fff", fontSize: 20 }}>Impresión General de Contribuyentes Publicidad Comercial por Sector</div>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={salir}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#ffffff", color: "" }}>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                   onHide={handleCloseMensa} />
              <Dimmer active={activate} inverted>
      </Dimmer>
                <div style={{ height: "auto", overflow: "auto" }}>

                    <h2 style={{ textAlign: "center" }}>Listado General de Contribuyentes por Sector</h2>
                    <hr />
                    <div className="container row">
                        <div className="input-group input-group-sm mb-4 col-md-6">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Año de la Publicidad: </span>
                            </div>
                            <select name="anioTasa" ref={txtAnio} className="form-control col-md-3 text-center">
                                {anio && anio.map(a => (
                                    <option key={a.anio} value={a.anio}>{a.anio}</option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group input-group-sm mb-4 col-md-6">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Tipo: </span>
                            </div>
                            <select name="" ref={cmbTipo} className="form-control text-center" >
                                <option value={""}>---Seleccionar Tipo---</option>
                                <option value={"PERMANENTE"}>PERMANENTE</option>
                                <option value={"TRANSEUNTE"}>TRANSEUNTER</option>
                                <option value={"EVENTUAL O AMBULANTE"}>EVENTUAL O AMBULANTE</option>
                                <option value={"IRREGULAR"}>IRREGULAR</option>
                                <option value={"REVISADO / CERRADO"}>REVISADO/CERRADO</option>
                                <option value={"TODOS"}>TODOS</option>
                            </select>
                        </div>
                    </div>
                    <hr />
                    <div className="container row">
                        <div className="input-group input-group-sm mb-4 col-md-6">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Desde Sector Cobranza N°: </span>
                            </div>
                            <input type="text" ref={txtSectorDesde} className="form-control text-uppercase" placeholder='DESDE 1' required />
                        </div>
                        <div className="input-group input-group-sm mb-4 col-md-6">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Hasta Sector Cobranza N°: </span>
                            </div>
                            <input type="text" ref={txtSectorHasta} className="form-control text-uppercase" placeholder='HASTA 4' required />
                        </div>
                    </div>
                    <hr />
                    <div className="container row col-md-10 mx-auto was-validated" style={{ fontWeight: 600 }}>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck1" ref={txtActivo} required />
                            <label className="form-check-label" for="validationFormCheck1">Activo</label>
                            <div className="invalid-feedback"></div>
                        </div>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck2" ref={txtInactivo} required />
                            <label className="form-check-label" for="validationFormCheck2">Inactivo</label>
                            <div className="invalid-feedback"></div>
                        </div>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck3" ref={txtClausurado} required />
                            <label className="form-check-label" for="validationFormCheck3">Clausurado</label>
                            <div className="invalid-feedback"></div>
                        </div>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck4" ref={txtFiscal} required />
                            <label className="form-check-label" for="validationFormCheck4">Fiscal</label>
                            <div className="invalid-feedback"></div>
                        </div>
                    </div>
                    <div className="container row col-md-10 mx-auto was-validated" style={{ fontWeight: 600 }}>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck5" ref={txtNotificado} required />
                            <label className="form-check-label" for="validationFormCheck5">Notificado</label>
                            <div className="invalid-feedback"></div>
                        </div>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck6" ref={txtDpLegal} required />
                            <label className="form-check-label" for="validationFormCheck6">Dep. Legal</label>
                            <div className="invalid-feedback"></div>
                        </div>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck7" ref={txtExonerado} required />
                            <label className="form-check-label" for="validationFormCheck7">Exonerado</label>
                            <div className="invalid-feedback"></div>
                        </div>
                        <div className="form-check mb-3 col-md-3">
                            <input type="checkbox" className="form-check-input" id="validationFormCheck8" ref={txtRCerrado} required />
                            <label className="form-check-label" for="validationFormCheck8">Rev/Cerrado</label>
                            <div className="invalid-feedback"></div>
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-print">  Imprimir</i></button>
                <button ref={btnSalir} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill"><i className="fa fa-sign-out">  Salir</i></button>
            </Modal.Footer>
        </Modal>
    );
}